import store from "../store/index";
//----------------------
// get visibility image
//----------------------
export default function getVisibilityImage(this_visibility) {
  //----------------------
  // get all visibilities
  //----------------------
  const this_store = store;
  const visibilities = this_store.getters["combat/getVisibilities"];
  //-----------------------------
  // get matching visibility obj
  //-----------------------------
  let obj = visibilities.find((a) => a.name == this_visibility);
  return obj.image;
}